import { useState } from 'react';

export default function BusinessUserMgrModel() {
  const [msgId, setMsgId] = useState('');

  return {
    msgId,
    setMsgId,
  };
}
